import React from 'react'
import InventorySalesView from '../../containers/Inventory/InventorySales/InventorySales'


const InventorySales = () => {
  return (
    <InventorySalesView/>
  )
}

export default InventorySales